import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../components/Logo";
import OtpInput from "../../components/OtpInput";
import { RESET_EMAIL_KEY } from "./ForgotPassword";

const RESET_CODE_KEY = "agbaza.reset.code";

export default function EtablissementCode() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("".padEnd(6, " "));
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const stored = sessionStorage.getItem(RESET_EMAIL_KEY);
    if (stored) setEmail(stored);
    else navigate("/etablissement/mot-de-passe/oubli", { replace: true });
  }, [navigate]);

  const codeValue = code.replace(/\s/g, "");
  const ready = codeValue.length === 6 && !submitting;

  const onConfirm = () => {
    if (!ready || !email) return;
    setError("");
    setSubmitting(true);
    sessionStorage.setItem(RESET_CODE_KEY, codeValue);
    setSubmitting(false);
    navigate("/etablissement/mot-de-passe/nouveau");
  };

  if (!email) return null;

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 relative">
      {/* Mobile background image */}
      <div className="absolute inset-0 md:hidden">
        <img src={'/maps-login-side.jpg'} alt="code" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-white/30" />
      </div>

      {/* Left: form */}
      <div className="relative flex items-center justify-center px-4 md:px-10 py-10">
        <div className="w-full max-w-md">
          <div className="flex justify-center"><Logo size={56} /></div>
          <h1 className="mt-6 text-2xl md:text-3xl font-semibold text-[#0B1F16]">
            Récupération du mot de passe
          </h1>
          <p className="mt-2 text-sm text-gray-600">
            Un code vous a été envoyé sur votre adresse mail <b>{email}</b>.
          </p>

          {error && (
            <div className="mt-4 text-sm text-red-600 bg-red-50 border border-red-200 rounded-[10px] px-3 py-2">
              {error}
            </div>
          )}

          <div className="mt-6">
            <div className="max-w-sm mx-auto">
              <OtpInput value={code} onChange={setCode} length={6} fullWidth />
            </div>
            <div className="mt-3 text-sm font-semibold" style={{ color: "#00553E" }}>
              Vous n'avez pas reçu de code ?
            </div>
          </div>

          <div className="mt-6 space-y-3">
            <button
              type="button"
              className="w-full h-12 rounded-[10px] font-semibold cursor-pointer disabled:opacity-60"
              style={{ backgroundColor: ready ? "#00553E" : "#DCEFE9", color: ready ? "#FFFFFF" : "#7aa79a" }}
              disabled={!ready}
              onClick={onConfirm}
            >
              {submitting ? "…" : "Confirmer"}
            </button>
            <Link to="/etablissement/connexion" className="block">
              <button type="button" className="w-full h-12 rounded-[10px] font-semibold border cursor-pointer" style={{ borderColor: "#D1E2DD", color: "#00553E" }}>
                Retour
              </button>
            </Link>
          </div>
        </div>
      </div>

      {/* Right: image (desktop) */}
      <div className="relative hidden md:block">
        <img src={'/maps-login-side.jpg'} alt="code" className="absolute inset-0 w-full h-full object-cover" />
      </div>
    </div>
  );
}
